import { Flex, FormControl, FormLabel, Input, InputRightElement, InputGroup } from '@chakra-ui/core'
import { InputProps } from '@chakra-ui/core/dist/Input'
import { useField } from 'formik'
import * as React from 'react'
import { Text } from '../../../typography'
import { sanitiseNumericInput } from '../ConnectedNumberInput'
import { LabelProps } from '../styles'

export type ConnectedMetricSpecificProps = LabelProps &
  InputProps & {
    label?: string
    name: string
    metric?: string
  }

const ConnectedMetricSpecific: React.FC<ConnectedMetricSpecificProps> = ({
  label,
  metric,
  ...rest
}) => {
  const [field, meta] = useField<{
    value: string
    metric: string
  }>(rest.name)

  const name = field.name
  return (
    <Flex flexDirection="column" width="100%" mr={rest.mr} ml={rest.ml} mt={rest.mt} mb={rest.mb}>
      <FormControl>
        {label && (
          <FormLabel fontWeight="normal" fontSize="sm" htmlFor={field.name}>
            {label}
          </FormLabel>
        )}
        <InputGroup>
          <Input
            focusBorderColor="accent.500"
            {...field}
            id={name}
            {...rest}
            type="text"
            inputMode="decimal"
            autoComplete="off"
            fontSize="sm"
            fontWeight="bold"
            value={field.value?.value ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // Kept as typed (see sanitiseNumericInput): re-parsing every
              // keystroke with parseFloat ate the "." of "1." and the "-" of a
              // negative, so unbounded metric fields couldn't take such values.
              const value = sanitiseNumericInput(e.target.value)
              if (value === null) return
              field.onChange({
                target: {
                  name: field.name,
                  value: {
                    value,
                    metric: metric || ''
                  }
                }
              })
            }}
          />
          {metric && (
            <InputRightElement fontSize="xs" color="green.500" fontWeight="bold">
              {metric}
            </InputRightElement>
          )}
        </InputGroup>
        {meta.touched && meta.error ? (
          <Text color="red.500" fontSize="xs">
            {(meta.error as any).value || (meta.error as any).metric || 'Invalid value'}
          </Text>
        ) : null}
      </FormControl>
    </Flex>
  )
}

export default ConnectedMetricSpecific

ConnectedMetricSpecific.defaultProps = {
  mb: 2,
  type: 'text',
  variant: 'filled'
}
